export const SORT_DIR = {
    DESC: 'DESC',
    ASC: "ASC"
};
